// @flow
import React from 'react'
import { EXCHANGE_BASE_URL, EXCHANGE_IMAGES_PATH, DEVICES } from '../../../constants'
import { getRedirectOptions } from '../../utils/Admon'
import LinkHandler from '../../utils/LinkHandler'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import { type FinanceImageBoxWrapperProps } from './Types'
import { composeUnversionedStaticsPath } from '../../utils/URL'

declare var UNVERSIONED_STATICS_PATH: string

export default (props: FinanceImageBoxWrapperProps) => {
  const {
    activeDynamicLayout,
    admon,
    box: {
      featuredType,
      goD = 0,
      goM = 0,
      guid,
      images,
      link,
      source,
      title
    },
    imageBoxComponent: ImageBoxComponent,
    imageSize,
    index,
    utmParams
  } = props

  let image = ''
  let enhancedLink = ''

  if (source.indexOf('ExchangeArticles') > -1) {
    image = `${UNVERSIONED_STATICS_PATH}${EXCHANGE_IMAGES_PATH.ARTICLES}${images[imageSize]}`

    const redirectOptions = getRedirectOptions(admon, activeDynamicLayout)
    enhancedLink = new LinkHandler(`${EXCHANGE_BASE_URL}?go=${activeDynamicLayout === DEVICES.DESKTOP ? goD : goM}`).applySASRedirect(redirectOptions).link
  } else {
    image = composeUnversionedStaticsPath(images[imageSize], UNVERSIONED_STATICS_PATH)

    const utmLinkParams = Object.assign({}, utmParams, {
      utmTerm: `position-${index}`,
      utmCampaign: source
    })
    enhancedLink = utmLinkGenerator.createLink(link, utmLinkParams)
  }

  return (
    <ImageBoxComponent
      featuredType={featuredType}
      image={image}
      imageClass={`image-${imageSize}`}
      isImage={true}
      key={guid}
      link={enhancedLink}
      title={title}
    />
  )
}
